import React from 'react';
import { isIE, isWindows7 } from '../../../../utils/isBrowser';

const Video = props =>
  <video src={props.url} controls></video>;

const VideoLink = props =>
  <p>
    <a href={props.url}>{props.url}</a>
  </p>;

export const VideoContents = props => {
  return isIE() && isWindows7()
    ? <VideoLink url={props.url} />
    : <Video url={props.url} />;
}
